import { apikoApi } from './utils';

/**
 * initializeClientFeedback :: (ID, String, String) -> Promise Error Object
 */
export const initializeClientFeedback = (feedbackId, rate, fingerPrint) =>
  apikoApi({
    method: 'PATCH',
    url: `/feedback/${feedbackId}`,
    data: { rate, fingerPrint },
  });

/**
 * submitClientFeedback :: (ID, String, String) -> Promise Error Object
 */
export const submitClientFeedback = (feedbackId, text, fingerPrint) =>
  apikoApi({
    method: 'PATCH',
    url: `/feedback/${feedbackId}`,
    data: { text, fingerPrint },
  });



// WEBPACK FOOTER //
// ./src/api/apiko-api/clients-feedback.js